var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors,
    transitions = _ref.transitions;
  return {
    placeholderColor: colors.contrasts.grey4570,
    placeholderPadding: spacing.xSmall,
    placeholderBorder: borders.widthSmall,
    placeholderBorderColor: colors.contrasts.grey4570,
    placeholderBorderRadius: borders.radiusMedium,
    dragTargetBorderColor: colors.contrasts.grey1214,
    dragTargetBorderRadius: borders.radiusMedium,
    dragTargetMargin: spacing.xSmall,
    dragTargetPadding: spacing.xSmall,
    dragTargetBorderWidth: borders.widthMedium,
    focusBorderColor: colors.contrasts.blue4570,
    focusBorderRadius: borders.radiusMedium,
    focusBorderWidth: borders.widthSmall,
    dragTargetTransition: "all ".concat(transitions.duration)
  };
};
export default generateComponentTheme;